import * as Yup from 'yup';

export const FinancialFormValidationSchema = Yup.object().shape({
  carry: Yup.number().required('errors.required'),
  fee: Yup.number().required('errors.required'),
  funding_goal: Yup.number().required('errors.required'),
  min_funding_goal: Yup.number().required('errors.required'),
  min_investment: Yup.number().required('errors.required'),
});
